import React, {useEffect, useState, Fragment} from 'react';
import flatstore from 'flatstore';
import Loader from '../../components/ui/Loader';
import parse from 'html-react-parser';
import {getFAQ, getStaticPage} from '../../utils/services';
import DataFilter from '../../components/ui/DataFilter'
import LoadModules from '../../components/ui/LoadModules';
import Meta from '../../components/ui/Meta';
import {isNull, isNil, isEmpty} from 'lodash';
import W from '../../components/ui/Word';
import { useTranslation } from 'react-i18next';
import SearchState from '../../components/ui/SearchState';
import { accentsTidy } from '../../utils/functions';

const Faq = ({match, loading, faq_data, faq_static}) => {
  const [data, setData] = useState();
  const [staticData, setStaticData] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [modules, setModules] = useState(null);
  const [filterType, setFilterType] = useState([]);
  const [searchStatus, setSearchStatus] = useState(null);
  const { t, i18n } = useTranslation();
  
  const {filter} = match.params;
  
  
  useEffect(() => {
    if (isNil(faq_data)) {
      getFAQ();
      getStaticPage('faq', 'faq_static');
    }
    if(faq_data && faq_data.data !== undefined){
      setData(faq_data.data);

      if(filter){
        //console.log(filter)
        setFilterType(t(filter));
      }else{
        setFilterType(null)
      }

      var fdata = [];
      faq_data.data.map((item)=>{
        //console.log(item.animal_type);
        if(filter){
          //console.log(item);
          if(item.animal_type.includes(t(filter))){
            fdata.push(item);
          }
        }else{
          if(item.animal_type.toLowerCase() == "general"){
            fdata.push(item);
          }
        }
      })
      
      setFilteredData(fdata);
      //console.log(filter, filterType);
     
      
      //setFilteredData(faq_data.data);
    }
  }, [faq_data]);
  
  useEffect(() => {
    if(data){
        if(filter){
          setFilterType(t(filter));
          //filterFunc({value:t(filter), pageNumber:null})
        }else{
          setFilterType(null)
          //filterFunc({value:null, pageNumber:null})
        }
    }
    
  }, [filter])


  useEffect(() => {
		if(faq_static !== undefined){
			setStaticData(faq_static);
			if(faq_static.modules && faq_static.modules.module !== null){
				setModules(faq_static.modules);
			}
		}
  }, [faq_static])
  
  const filterFunc = ({pageNumber, value, search, searchState}) =>{
    if(searchState == "search_empty"){
      setSearchStatus('only3char');
			setFilteredData([]);
      return false;
    }
    if(value == null)
      value = "general";
    if(!isNil(search) && search.length > 0){
      search = search.toLowerCase();
			var fdata = [];
			if(search.length < 2){
				setSearchStatus('3char');
				setFilteredData(fdata);
			}else{
				data.map((item, index)=>{
					if(accentsTidy(item.question).includes(search)){
						fdata.push(item);
					}
				});
				if(fdata.length < 1){
          setSearchStatus('noresult');
          setFilteredData(fdata);
				}else{
					fdata.total = 100;
					fdata.per_page = 1000;
					setFilteredData(fdata);
					setSearchStatus(null);
				}
				
			}
		}else{
      setSearchStatus(null);
      var fdata = [];
      //console.log(value);
      //if(value != filterType){
        data.map((item)=>{

          if(isNull(value)){
            if(item.animal_type.toLowerCase() == "general"){
              fdata.push(item);
            }
          }else{
            if(item.animal_type.includes(value)){
              fdata.push(item);
            }
          }
            
        })
      //}
      setFilteredData(fdata);
    }
  }

  if (loading) {
    return <Loader />
  } else {
    return (
      <Fragment>
      <LoadModules modules={modules} type="top" />
      <div className="container mt-40">
        <div className="row">
            {staticData &&
              <Fragment>
              <Meta
                title={staticData.seo_title}
                description={staticData.seo_description && staticData.seo_description}
                type="website"
                image={staticData.image_url}
              />
              {staticData.body &&
                <div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2 mb-10">
                  <h1 className="heading--h1">{staticData.title}</h1>
                  <p>{parse(staticData.body)}</p>
                </div>
              }
              </Fragment>
            }
          </div>

          <DataFilter type="faq" filterFunc={filterFunc} filterType={filterType} data={data} />
            
          <div className="row">
          <div className="col-12 col-md-7 mb-80">
            <div className="">

              {filteredData && filteredData.map((item, index) => {
                  return (<div key={index} className="faq__item">
                    <details>
                      <summary> <span>{item.question}</span> </summary>
                      <div className="faq__body">{item.answer && parse(item.answer)}</div>
                    </details>
                  </div>)
                })
              }
              <SearchState status={searchStatus} />
            </div>

          </div>
          
          <div className="col-12 col-md-4 offset-md-1 mb-80">

              <div className="contact__box">

                <div className="contact__item">
                  <h4 className="heading--h4"><W>faq.contact.title</W></h4>
                  <p className="mb-0">
                    <W>faq.contact.body</W>
                  </p>
                </div>
                {t('contact.phone') != "" && 
                  <a href={t("contact.phone_url")} className="contact__item contact--lefticon">
                    <i className="icon-phone"></i> <W>contact.phone</W>
                  </a>
                }

                <a href={t("contact.email_url")} className="contact__item contact--lefticon">
                  <i className="icon-email"></i> <W>contact.email</W>
                </a>
                {t('contact.facebook_url') != "" && 
                  <a target="_blank" href={t("contact.facebook_url")} className="contact__item contact--lefticon">
                    
                    <i className="icon-facebook"></i> <W>contact.facebook</W>
                  </a>
                }
                {t('contact.twitter_url') != "" && 
                  <a target="_blank" href={t("contact.twitter_url")} className="contact__item contact--lefticon">
                    <i className="icon-twitter"></i> <W>contact.twitter</W>
                  </a>
                }
                {t('contact.instagram_url') != "" && 
                  <a target="_blank" href={t("contact.instagram_url")} className="contact__item contact--lefticon">
                    <i className="icon-instagram"></i> <W>contact.instagram</W>
                  </a>
                }
              
              </div>
              <div className="mt-30">
                <h4 className="heading--h4"> <W>faq.company.name</W> </h4>
                <p>
                  <W>faq.company.address</W>
                </p>
              </div>

          </div>
        </div>      
      </div>
      <LoadModules modules={modules} type="bottom" />
      </Fragment>
    )
  }
}

export default flatstore.connect(['loading', 'faq_data', 'faq_static'])(Faq);
